<template>
  <div class="flex w-full h-full draw">
    <!-- <div class="h-full sider-wrapper" v-if="!hideSidebar"> -->
    <div class="h-full sider-wrapper" style="width: 256px" v-if="!hideSidebar">
      <SiderbarVue :nodes="props.nodes" :graph="graph" :card="props.card">
        <template #sidebar>
          <slot name="sidebar"></slot>
        </template>
      </SiderbarVue>
    </div>

    <div class="flex flex-col flex-1 w-1 px-4">
      <!-- <div class="w-full border-b border-gray-100 shadow toolbar"></div> -->
      <div class="flex items-center justify-between">
        <Toolbar :graph="graph" :toolbar="toolbar" v-if="showToolbar" />
        <div>
          <slot name="topRightContent"> </slot>
        </div>
      </div>
      <div class="relative flex flex-1 w-full">
        <div class="flex-1 h-full editor-container"></div>
        <FormatPanel
          :graph="graph"
          :handleGeomertyChange="handleGeomertyChange"
          :handleStyleChange="handleStyleChange"
        />
        <div class="editor-outline">
          <el-collapse v-model="foldAvigraph">
            <el-collapse-item name="avigraph">
              <template #title>
                <div class="editor-avigraph-title">
                  <div class="editor-avigraph-icon">
                    <el-icon>
                      <Position />
                    </el-icon>
                  </div>
                  <span>导航器</span>
                </div>
              </template>
              <div class="editor-avigraph"></div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div>
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'Draw'
}
</script>
<script setup lang="ts">
interface DrawProps {
  graph?: _VTI_TYPE_MyGraph
  nodes: SidebarNode[]
  card?: boolean
  graph?: _VTI_TYPE_MyGraph
  toolbar?: iToolbarSection[]
  hideSidebar?: boolean
  handleAddVertex?: (cell: mxCell, x: number, y: number, target: mxCell) => void
  handleDeleteCell?: (cell: mxCell) => void
  handleAddEdge?: (cell: mxCell) => void
  handleMoveCell?: (cell: mxCell) => void
  cellRightClick?: (cells: mxCell[], menu: mxPopupMenuHandler) => void
  beforeDeleteCell?: (cell: mxCell) => boolean
  beforeAddVertex?: (cell: mxCell) => boolean
  handleRotate?: (cell: mxCell) => void
  handleGeomertyChange?: (
    cells: mxCell[],
    key: string,
    value: number | string
  ) => void
  handleStyleChange?: (
    cells: mxCell[],
    key: string,
    value: number | string | [string[], (string | null)[]]
  ) => void
  outlineMap?: boolean
  showHoverIcon?: boolean
  hoverIconHandler?: (type: string, evt: MouseEvent, cell: mxCellState) => void
}
import { mxCell as typeMxCell, mxPopupMenuHandler, mxConnectionHandler } from 'mxgraph'
import { onMounted, ref, shallowRef, unref } from 'vue'
import mx from './factory'
import MyGraph from './graph'
import SiderbarVue from './siderbar.vue'
import Toolbar from './toolbar.vue'
import '../index.css'
import { DrawInstance, SidebarNodeConfig } from './type/type'
import { Position } from '@element-plus/icons-vue'
import FormatPanel from './FormatPanel.vue'
const props = defineProps<DrawProps>()
const graph = shallowRef<MyGraph>()
const foldAvigraph = ref('avigraph')
onMounted(() => {
  const editor = new mx.mxEditor()
  editor.graph = new MyGraph(
    document.querySelector('.editor-container') as HTMLElement
  )
  graph.value = editor.graph as MyGraph
  graph.value.handleAddVertex = props.handleAddVertex
  graph.value.handleDeleteCell = props.handleDeleteCell
  graph.value.handleAddEdge = props.handleAddEdge
  graph.value.handleMoveCell = props.handleMoveCell
  graph.value.cellRightClick = props.cellRightClick
  graph.value.beforeDeleteCell = props.beforeDeleteCell
  graph.value.beforeAddVertex = props.beforeAddVertex
  graph.value.handleRotate = props.handleRotate
  graph.value.showHoverIcon = props.showHoverIcon
  graph.value.hoverIconHandler = props.hoverIconHandler
  graph.value._init()
  window.graph = unref(graph.value)
  //鸟瞰图
  if (props.outlineMap) {
    new mx.mxOutline(
      graph.value,
      document.querySelector('.editor-avigraph') as HTMLElement
    )
  }
})
const showToolbar = ref<boolean>(true)
const reloadToolbar = () => {
  showToolbar.value = false
  setTimeout(() => {
    showToolbar.value = true
  }, 0)
}
defineExpose({
  graph: graph,
  reloadToolbar
})
</script>

<style lang="scss">
.draw {
  @apply relative;

  .toolbar {
    @apply h-8;
  }

  .editor-outline {
    @apply absolute top-0 right-2 w-48 bg-white shadow border;
    top: 1rem;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 50px #e5f1ff;

    .el-collapse-item__header {
      background: #e5f1ff;
      color: #0574ff;

      .el-collapse-item__arrow {
        transform: rotate(-90deg);

        &.is-active {
          transform: rotate(90deg);
        }
      }
    }

    .el-collapse-item__content {
      padding: 0;
    }
  }
}

.editor-avigraph-title {
  padding: 0.3rem;
  font-size: 16px;
  display: flex;
  padding-left: 1rem;
  padding-right: 1rem;
  align-items: center;

  .editor-avigraph-icon {
    height: 1.2rem;
    width: 1.2rem;
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid #0574ff;

    .el-icon {
      height: 0.8rem;
      width: 0.8rem;
      transform: translate(0, 0.05rem) rotate(-45deg);
    }
  }
}

.header-content {
  justify-content: space-between;
}

div.mxRubberband {
  position: absolute;
  overflow: hidden;
  border-style: solid;
  border-width: 1px;
  border-color: #0000ff;
  background: #0077ff;
}
</style>
<style>
div.mxPopupMenu {
  -webkit-box-shadow: 3px 3px 6px #c0c0c0;
  -moz-box-shadow: 3px 3px 6px #c0c0c0;
  box-shadow: 3px 3px 6px #c0c0c0;
  background: white;
  position: absolute;
  border: 3px solid #e7e7e7;
  padding: 3px;
}

table.mxPopupMenu {
  border-collapse: collapse;
  margin: 0px;
}

tr.mxPopupMenuItem {
  color: black;
  cursor: pointer;
}

td.mxPopupMenuItem {
  padding: 6px 60px 6px 30px;
  font-family: Arial;
  font-size: 10pt;
  user-select: none;
}

td.mxPopupMenuIcon {
  background-color: white;
  padding: 0px;
}

tr.mxPopupMenuItemHover {
  background-color: #eeeeee;
  color: black;
}

table.mxPopupMenu hr {
  border-top: solid 1px #cccccc;
}

table.mxPopupMenu tr {
  font-size: 4pt;
}
</style>
